import styled from 'styled-components';
import {CssRule} from "../../../../themes/architecture/css-helpers/css-rule";

export const MenuContainerBox = styled.div`
    width: 100%;
    
    .main-nav-menu-list .main-nav-menu-item a.nav-menu-link {
        position: relative;
        font-size: 12px;
        font-family: ${props => props.theme.font.family.regular};
        padding: 12px 0;
        
        &:after {
          content: "";
          position: absolute;
          right: 5px;
          background-image: url("${props => props.theme.images.spriteSheet.toString()}");
          background-repeat: no-repeat; 
          ${CssRule.For.RTL.build()} & {
            transform: scaleX(-1);
          }
          
          top: 2rem;
          width: 15px;
          height: 15px;
          background-position: -751px -655px;
          transform: scale(0.8);
        }
        
        &:before {
            margin-right: 10px;
        }
    }
`;